import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { map, isEqual, isEmpty } from "lodash";
import { getClassName } from "../../../ui-kit/utils/component";
import Chart from "chart.js";
import DateHelper from "../../../utils/date";
import { money } from "../../../utils/currencyHelper";

import "./TickersChart.scss";

const ccn = getClassName("tickers-chart");

class TickersChart extends Component {
  static defaultProps = {
    tickers: []
  };

  constructor(props, ...args) {
    super(props, args);

    this.state = {
      activeRange: "1m"
    };

    this.chart = null;
    this.canvas = null;
    this.data = null;
  }

  componentWillUpdate(nextProps, nextState) {
    const data = this.normalizeData(nextState.activeRange);

    if (!isEmpty(data)) {
      setTimeout(() => this.displayChart(data), 500);
    }
  }

  componentDidMount() {
    const { activeRange } = this.state;
    const data = this.normalizeData(activeRange);

    if (!isEmpty(data)) {
      setTimeout(() => this.displayChart(data), 500);
    }
  }

  changeRange = e => this.setState({ activeRange: e.target.innerText });

  getData(period) {
    const { tickers } = this.props;
    const PERIODS = {
      "1m": 1,
      "3m": 3,
      "1y": 12
    };

    if (!PERIODS[period]) return tickers;

    return tickers.filter(({ timestamp }) => {
      const d = new Date();
      d.setMonth(d.getMonth() - PERIODS[period]);
      return timestamp >= d.getTime();
    });
  }

  normalizeData(period) {
    return this.getData(period).map(val => ({ x: new Date(val.timestamp), y: parseFloat(val.ticker, 10) }));
  }

  checkDataUpdate(data) {
    if (!isEqual(this.data, data)) {
      this.data = data;
      return true;
    }
    return false;
  }

  displayChart = (data) => {
    const isUpdate = this.checkDataUpdate(data);

    if (this.canvas && isUpdate) {
      const ctx = this.canvas.getContext("2d");
      const labels = map(data, "x");
      const dataset = map(data, "y");

      if (this.chart instanceof Chart) {
        this.chart.data.datasets[0].data = dataset;
        this.chart.data.labels = labels;
        return this.chart.update();
      }

      this.chart = new Chart(ctx, {
        type: "line",
        data: {
          datasets: [{
            label: "Performance",
            data: dataset,
            backgroundColor: [
              "rgba(255, 99, 132, 0)"
            ],
            borderColor: [
              "rgba(118,205,155,1)"
            ],
            borderWidth: 3,
            pointRadius: 0,
            fill: false,
            lineTension: 0.2
          }],
          labels
        },
        options: {
          legend: {
            display: false
          },
          animation: {
            duration: 0
          },
          tooltips: {
            intersect: false,
            callbacks: {
              title: (tooltipItems, chartData) => {
                const { index } = tooltipItems[0];
                const date = chartData.labels[index];
                return new DateHelper(date).format("mmm dd, yyyy h:MM TT");
              },
              labelColor: () => ({
                borderColor: 'rgba(118,205,155,1)',
                backgroundColor: 'rgba(118,205,155,1)'
              }),
              label: tooltipItems => (
                `Perfomance: ${tooltipItems.yLabel}`
              )
            }
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false
              },
              ticks: {
                autoSkip: true
              },
              type: "time",
              time: {
                unit: "day"
              }
            }],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true
                },
                scaleLabel: {
                  display: true,
                  labelString: "$1000 Invested"
                }
              }
            ]
          }
        }
      });
    }
  };

  render() {
    const { userBalance } = this.props;
    if (!userBalance) return null;

    return (
      <React.Fragment>
        <div className={ccn()}>
          <h2 className={ccn("title left")}>
            <FormattedMessage
              id="hbc.dashboard.hedged.bitcoin.performance"
              defaultMessage="hedged bitcoin performance"
            />
          </h2>
          <ul className={ccn("range")}>
            <li className={this.state.activeRange === "1m" ? "active" : ""} onClick={this.changeRange}>1m</li>
            <li className={this.state.activeRange === "3m" ? "active" : ""} onClick={this.changeRange}>3m</li>
            <li className={this.state.activeRange === "1y" ? "active" : ""} onClick={this.changeRange}>1y</li>
            <li className={this.state.activeRange === "All" ? "active" : ""} onClick={this.changeRange}>All</li>
          </ul>
          <canvas ref={(el) => { this.canvas = el; }} width="400" height="250" />
        </div>
      </React.Fragment>
    );
  }
}

export default injectIntl(TickersChart);



// WEBPACK FOOTER //
// ./src/containers/dashboard/tickersChart/TickersChart.js